// source: profileservice/blog_top.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.profileservice.GetBlogTopContentReply', null, global);
goog.exportSymbol('proto.profileservice.GetBlogTopContentRequest', null, global);
goog.exportSymbol('proto.profileservice.PopularBlog', null, global);
goog.exportSymbol('proto.profileservice.RecommendationBlog', null, global);
goog.exportSymbol('proto.profileservice.RecommendationCategoryBlog', null, global);
goog.exportSymbol('proto.profileservice.RecommendationUser', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogTopContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.GetBlogTopContentRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.GetBlogTopContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogTopContentRequest.displayName = 'proto.profileservice.GetBlogTopContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogTopContentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.GetBlogTopContentReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.GetBlogTopContentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogTopContentReply.displayName = 'proto.profileservice.GetBlogTopContentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.PopularBlog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.PopularBlog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.PopularBlog.displayName = 'proto.profileservice.PopularBlog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.RecommendationBlog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.RecommendationBlog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.RecommendationBlog.displayName = 'proto.profileservice.RecommendationBlog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.RecommendationUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.RecommendationUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.RecommendationUser.displayName = 'proto.profileservice.RecommendationUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.RecommendationCategoryBlog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.RecommendationCategoryBlog.repeatedFields_, null);
};
goog.inherits(proto.profileservice.RecommendationCategoryBlog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.RecommendationCategoryBlog.displayName = 'proto.profileservice.RecommendationCategoryBlog';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.GetBlogTopContentRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogTopContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogTopContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogTopContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogTopContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogTopContentRequest}
 */
proto.profileservice.GetBlogTopContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogTopContentRequest;
  return proto.profileservice.GetBlogTopContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogTopContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogTopContentRequest}
 */
proto.profileservice.GetBlogTopContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogTopContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogTopContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogTopContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogTopContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.GetBlogTopContentRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogTopContentRequest} returns this
 */
proto.profileservice.GetBlogTopContentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 blog_ids = 2;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogTopContentRequest.prototype.getBlogIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogTopContentRequest} returns this
 */
proto.profileservice.GetBlogTopContentRequest.prototype.setBlogIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogTopContentRequest} returns this
 */
proto.profileservice.GetBlogTopContentRequest.prototype.addBlogIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentRequest} returns this
 */
proto.profileservice.GetBlogTopContentRequest.prototype.clearBlogIdsList = function() {
  return this.setBlogIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.GetBlogTopContentReply.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogTopContentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogTopContentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogTopContentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogTopContentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    popularBlogsList: jspb.Message.toObjectList(msg.getPopularBlogsList(),
    proto.profileservice.PopularBlog.toObject, includeInstance),
    paidBlogsList: jspb.Message.toObjectList(msg.getPaidBlogsList(),
    proto.profileservice.RecommendationBlog.toObject, includeInstance),
    freeBlogsList: jspb.Message.toObjectList(msg.getFreeBlogsList(),
    proto.profileservice.RecommendationBlog.toObject, includeInstance),
    favoriteBlogsList: jspb.Message.toObjectList(msg.getFavoriteBlogsList(),
    proto.profileservice.RecommendationBlog.toObject, includeInstance),
    categoryBlogsList: jspb.Message.toObjectList(msg.getCategoryBlogsList(),
    proto.profileservice.RecommendationCategoryBlog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogTopContentReply}
 */
proto.profileservice.GetBlogTopContentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogTopContentReply;
  return proto.profileservice.GetBlogTopContentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogTopContentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogTopContentReply}
 */
proto.profileservice.GetBlogTopContentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.PopularBlog;
      reader.readMessage(value,proto.profileservice.PopularBlog.deserializeBinaryFromReader);
      msg.addPopularBlogs(value);
      break;
    case 2:
      var value = new proto.profileservice.RecommendationBlog;
      reader.readMessage(value,proto.profileservice.RecommendationBlog.deserializeBinaryFromReader);
      msg.addPaidBlogs(value);
      break;
    case 3:
      var value = new proto.profileservice.RecommendationBlog;
      reader.readMessage(value,proto.profileservice.RecommendationBlog.deserializeBinaryFromReader);
      msg.addFreeBlogs(value);
      break;
    case 4:
      var value = new proto.profileservice.RecommendationBlog;
      reader.readMessage(value,proto.profileservice.RecommendationBlog.deserializeBinaryFromReader);
      msg.addFavoriteBlogs(value);
      break;
    case 5:
      var value = new proto.profileservice.RecommendationCategoryBlog;
      reader.readMessage(value,proto.profileservice.RecommendationCategoryBlog.deserializeBinaryFromReader);
      msg.addCategoryBlogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogTopContentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogTopContentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogTopContentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogTopContentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPopularBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.profileservice.PopularBlog.serializeBinaryToWriter
    );
  }
  f = message.getPaidBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.profileservice.RecommendationBlog.serializeBinaryToWriter
    );
  }
  f = message.getFreeBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.profileservice.RecommendationBlog.serializeBinaryToWriter
    );
  }
  f = message.getFavoriteBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.profileservice.RecommendationBlog.serializeBinaryToWriter
    );
  }
  f = message.getCategoryBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.profileservice.RecommendationCategoryBlog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PopularBlog popular_blogs = 1;
 * @return {!Array<!proto.profileservice.PopularBlog>}
 */
proto.profileservice.GetBlogTopContentReply.prototype.getPopularBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.PopularBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.PopularBlog, 1));
};


/**
 * @param {!Array<!proto.profileservice.PopularBlog>} value
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
*/
proto.profileservice.GetBlogTopContentReply.prototype.setPopularBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.profileservice.PopularBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.PopularBlog}
 */
proto.profileservice.GetBlogTopContentReply.prototype.addPopularBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.profileservice.PopularBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
 */
proto.profileservice.GetBlogTopContentReply.prototype.clearPopularBlogsList = function() {
  return this.setPopularBlogsList([]);
};


/**
 * repeated RecommendationBlog paid_blogs = 2;
 * @return {!Array<!proto.profileservice.RecommendationBlog>}
 */
proto.profileservice.GetBlogTopContentReply.prototype.getPaidBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.RecommendationBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.RecommendationBlog, 2));
};


/**
 * @param {!Array<!proto.profileservice.RecommendationBlog>} value
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
*/
proto.profileservice.GetBlogTopContentReply.prototype.setPaidBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.profileservice.RecommendationBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.GetBlogTopContentReply.prototype.addPaidBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.profileservice.RecommendationBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
 */
proto.profileservice.GetBlogTopContentReply.prototype.clearPaidBlogsList = function() {
  return this.setPaidBlogsList([]);
};


/**
 * repeated RecommendationBlog free_blogs = 3;
 * @return {!Array<!proto.profileservice.RecommendationBlog>}
 */
proto.profileservice.GetBlogTopContentReply.prototype.getFreeBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.RecommendationBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.RecommendationBlog, 3));
};


/**
 * @param {!Array<!proto.profileservice.RecommendationBlog>} value
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
*/
proto.profileservice.GetBlogTopContentReply.prototype.setFreeBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.profileservice.RecommendationBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.GetBlogTopContentReply.prototype.addFreeBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.profileservice.RecommendationBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
 */
proto.profileservice.GetBlogTopContentReply.prototype.clearFreeBlogsList = function() {
  return this.setFreeBlogsList([]);
};


/**
 * repeated RecommendationBlog favorite_blogs = 4;
 * @return {!Array<!proto.profileservice.RecommendationBlog>}
 */
proto.profileservice.GetBlogTopContentReply.prototype.getFavoriteBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.RecommendationBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.RecommendationBlog, 4));
};


/**
 * @param {!Array<!proto.profileservice.RecommendationBlog>} value
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
*/
proto.profileservice.GetBlogTopContentReply.prototype.setFavoriteBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.profileservice.RecommendationBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.GetBlogTopContentReply.prototype.addFavoriteBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.profileservice.RecommendationBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
 */
proto.profileservice.GetBlogTopContentReply.prototype.clearFavoriteBlogsList = function() {
  return this.setFavoriteBlogsList([]);
};


/**
 * repeated RecommendationCategoryBlog category_blogs = 5;
 * @return {!Array<!proto.profileservice.RecommendationCategoryBlog>}
 */
proto.profileservice.GetBlogTopContentReply.prototype.getCategoryBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.RecommendationCategoryBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.RecommendationCategoryBlog, 5));
};


/**
 * @param {!Array<!proto.profileservice.RecommendationCategoryBlog>} value
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
*/
proto.profileservice.GetBlogTopContentReply.prototype.setCategoryBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.profileservice.RecommendationCategoryBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.RecommendationCategoryBlog}
 */
proto.profileservice.GetBlogTopContentReply.prototype.addCategoryBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.profileservice.RecommendationCategoryBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogTopContentReply} returns this
 */
proto.profileservice.GetBlogTopContentReply.prototype.clearCategoryBlogsList = function() {
  return this.setCategoryBlogsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.PopularBlog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.PopularBlog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.PopularBlog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.PopularBlog.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isFavorited: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    isPurchased: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.PopularBlog}
 */
proto.profileservice.PopularBlog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.PopularBlog;
  return proto.profileservice.PopularBlog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.PopularBlog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.PopularBlog}
 */
proto.profileservice.PopularBlog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorited(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPurchased(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.PopularBlog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.PopularBlog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.PopularBlog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.PopularBlog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsFavorited();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsPurchased();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 blog_id = 1;
 * @return {number}
 */
proto.profileservice.PopularBlog.prototype.getBlogId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.PopularBlog} returns this
 */
proto.profileservice.PopularBlog.prototype.setBlogId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_favorited = 2;
 * @return {boolean}
 */
proto.profileservice.PopularBlog.prototype.getIsFavorited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.PopularBlog} returns this
 */
proto.profileservice.PopularBlog.prototype.setIsFavorited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_purchased = 3;
 * @return {boolean}
 */
proto.profileservice.PopularBlog.prototype.getIsPurchased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.PopularBlog} returns this
 */
proto.profileservice.PopularBlog.prototype.setIsPurchased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.RecommendationBlog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.RecommendationBlog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.RecommendationBlog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationBlog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogCategoryId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blogCategoryName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 5, ""),
    resizableCoverImagePath: jspb.Message.getFieldWithDefault(msg, 6, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 7, 0),
    user: (f = msg.getUser()) && proto.profileservice.RecommendationUser.toObject(includeInstance, f),
    price: jspb.Message.getFieldWithDefault(msg, 9, 0),
    paidFg: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    openedAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
    isFavorited: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    isPurchased: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.RecommendationBlog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.RecommendationBlog;
  return proto.profileservice.RecommendationBlog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.RecommendationBlog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.RecommendationBlog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogCategoryId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogCategoryName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setResizableCoverImagePath(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 8:
      var value = new proto.profileservice.RecommendationUser;
      reader.readMessage(value,proto.profileservice.RecommendationUser.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaidFg(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenedAt(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorited(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPurchased(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.RecommendationBlog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.RecommendationBlog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.RecommendationBlog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationBlog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBlogCategoryName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getResizableCoverImagePath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.profileservice.RecommendationUser.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPaidFg();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getOpenedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getIsFavorited();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsPurchased();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.RecommendationBlog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 blog_category_id = 2;
 * @return {number}
 */
proto.profileservice.RecommendationBlog.prototype.getBlogCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setBlogCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string blog_category_name = 3;
 * @return {string}
 */
proto.profileservice.RecommendationBlog.prototype.getBlogCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setBlogCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.profileservice.RecommendationBlog.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.profileservice.RecommendationBlog.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string resizable_cover_image_path = 6;
 * @return {string}
 */
proto.profileservice.RecommendationBlog.prototype.getResizableCoverImagePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setResizableCoverImagePath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 kind = 7;
 * @return {number}
 */
proto.profileservice.RecommendationBlog.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional RecommendationUser user = 8;
 * @return {?proto.profileservice.RecommendationUser}
 */
proto.profileservice.RecommendationBlog.prototype.getUser = function() {
  return /** @type{?proto.profileservice.RecommendationUser} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.RecommendationUser, 8));
};


/**
 * @param {?proto.profileservice.RecommendationUser|undefined} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
*/
proto.profileservice.RecommendationBlog.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.RecommendationBlog.prototype.hasUser = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 price = 9;
 * @return {number}
 */
proto.profileservice.RecommendationBlog.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool paid_fg = 10;
 * @return {boolean}
 */
proto.profileservice.RecommendationBlog.prototype.getPaidFg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setPaidFg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int64 opened_at = 11;
 * @return {number}
 */
proto.profileservice.RecommendationBlog.prototype.getOpenedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setOpenedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool is_favorited = 12;
 * @return {boolean}
 */
proto.profileservice.RecommendationBlog.prototype.getIsFavorited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setIsFavorited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_purchased = 13;
 * @return {boolean}
 */
proto.profileservice.RecommendationBlog.prototype.getIsPurchased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.RecommendationBlog} returns this
 */
proto.profileservice.RecommendationBlog.prototype.setIsPurchased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.RecommendationUser.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.RecommendationUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.RecommendationUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileIconPath: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.RecommendationUser}
 */
proto.profileservice.RecommendationUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.RecommendationUser;
  return proto.profileservice.RecommendationUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.RecommendationUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.RecommendationUser}
 */
proto.profileservice.RecommendationUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileIconPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.RecommendationUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.RecommendationUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.RecommendationUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileIconPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.RecommendationUser.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationUser} returns this
 */
proto.profileservice.RecommendationUser.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.profileservice.RecommendationUser.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationUser} returns this
 */
proto.profileservice.RecommendationUser.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_icon_path = 3;
 * @return {string}
 */
proto.profileservice.RecommendationUser.prototype.getProfileIconPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationUser} returns this
 */
proto.profileservice.RecommendationUser.prototype.setProfileIconPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.RecommendationCategoryBlog.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.RecommendationCategoryBlog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.RecommendationCategoryBlog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationCategoryBlog.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogCategoryId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogCategoryName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    blogsList: jspb.Message.toObjectList(msg.getBlogsList(),
    proto.profileservice.RecommendationBlog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.RecommendationCategoryBlog}
 */
proto.profileservice.RecommendationCategoryBlog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.RecommendationCategoryBlog;
  return proto.profileservice.RecommendationCategoryBlog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.RecommendationCategoryBlog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.RecommendationCategoryBlog}
 */
proto.profileservice.RecommendationCategoryBlog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogCategoryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogCategoryName(value);
      break;
    case 3:
      var value = new proto.profileservice.RecommendationBlog;
      reader.readMessage(value,proto.profileservice.RecommendationBlog.deserializeBinaryFromReader);
      msg.addBlogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.RecommendationCategoryBlog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.RecommendationCategoryBlog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.RecommendationCategoryBlog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogCategoryName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.profileservice.RecommendationBlog.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 blog_category_id = 1;
 * @return {number}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.getBlogCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.RecommendationCategoryBlog} returns this
 */
proto.profileservice.RecommendationCategoryBlog.prototype.setBlogCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string blog_category_name = 2;
 * @return {string}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.getBlogCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.RecommendationCategoryBlog} returns this
 */
proto.profileservice.RecommendationCategoryBlog.prototype.setBlogCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated RecommendationBlog blogs = 3;
 * @return {!Array<!proto.profileservice.RecommendationBlog>}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.getBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.RecommendationBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.RecommendationBlog, 3));
};


/**
 * @param {!Array<!proto.profileservice.RecommendationBlog>} value
 * @return {!proto.profileservice.RecommendationCategoryBlog} returns this
*/
proto.profileservice.RecommendationCategoryBlog.prototype.setBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.profileservice.RecommendationBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.RecommendationBlog}
 */
proto.profileservice.RecommendationCategoryBlog.prototype.addBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.profileservice.RecommendationBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.RecommendationCategoryBlog} returns this
 */
proto.profileservice.RecommendationCategoryBlog.prototype.clearBlogsList = function() {
  return this.setBlogsList([]);
};


goog.object.extend(exports, proto.profileservice);
